import { indexEntries } from '@/mocks/homeData';

export default function TodayIndex() {
  return (
    <section id="index" className="w-full bg-background-100">
      <div className="grid w-full grid-cols-1 gap-10 px-4 py-16 md:px-10 md:py-24 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <p className="text-xs tracking-[0.32em] text-primary-600">TODAY INDEX</p>
            <h2 className="mt-5 font-heading text-3xl font-bold tracking-tight text-foreground-950 md:text-4xl">
              今日索引
            </h2>
            <p className="mt-6 max-w-sm text-sm leading-loose text-foreground-600">
              按更新时间倒序排列的八个点位，每一条都注明线索方向与状态，点开后可直接进入对应的推荐合集。
            </p>
            <a
              href="#featured"
              className="mt-8 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap border-b border-foreground-900 pb-1 text-sm text-foreground-900 transition-colors hover:border-primary-500 hover:text-primary-600"
            >
              查看热门推荐
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="lg:col-span-8">
          <ul className="border-t border-background-200">
            {indexEntries.map((entry) => (
              <li key={entry.no} className="border-b border-background-200">
                <a
                  href="#featured"
                  className="group grid cursor-pointer grid-cols-[auto_1fr] items-start gap-x-5 gap-y-2 py-6 transition-colors md:grid-cols-[auto_1fr_auto] md:gap-x-8"
                >
                  <span className="font-heading text-2xl tabular-nums text-background-400 transition-colors group-hover:text-primary-500 md:text-3xl">
                    {entry.no}
                  </span>
                  <div>
                    <div className="flex flex-wrap items-center gap-2.5">
                      <span className="font-heading text-lg text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
                        {entry.name}
                      </span>
                      <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-900">
                        {entry.tag}
                      </span>
                    </div>
                    <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
                      {entry.desc}
                    </p>
                  </div>
                  <span className="col-start-2 flex items-center gap-1.5 text-xs text-foreground-500 md:col-start-auto md:pt-1.5">
                    <i className="ri-time-line"></i>
                    {entry.time}
                  </span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}